import React from 'react';
import { motion } from 'framer-motion';
import { X, Leaf } from 'lucide-react';
export function WhatItIs() {
  const notIs = ['una dieta extrema', 'una solución milagrosa', 'una promesa vacía', 'información superficial copiada de internet'];
  const is = ['una guía práctica y femenina', 'una ruta clara y organizada', 'un enfoque integral (cuerpo, hormonas, descanso, emociones)', 'un plan realista que se puede sostener', 'una herramienta para entender tu propio cuerpo'];
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-365">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink" data-id="element-366">
            Qué es realmente esta guía
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16" data-id="element-367">
          {/* LO QUE NO ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-ivory p-8 md:p-10 rounded-2xl border border-taupe/20" data-id="element-368">
            <h3 className="text-2xl font-serif text-muted mb-8 flex items-center gap-3" data-id="element-369">
              <span className="w-8 h-px bg-muted/30" data-id="element-370"></span>
              Lo que NO es
            </h3>
            <ul className="space-y-6" data-id="element-371">
              {notIs.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-372">
                  <X className="w-6 h-6 text-muted shrink-0" data-id="element-373" />
                  <span className="text-lg text-ink/70" data-id="element-374">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* LO QUE SÍ ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-sage/5 p-8 md:p-10 rounded-2xl border border-sage/20" data-id="element-375">
            <h3 className="text-2xl font-serif text-sage mb-8 flex items-center gap-3" data-id="element-376">
              <span className="w-8 h-px bg-sage/30" data-id="element-377"></span>
              Lo que SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-378">
              {is.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-379">
                  <Leaf className="w-6 h-6 text-sage shrink-0" data-id="element-380" />
                  <span className="text-lg text-ink/90 font-medium" data-id="element-381">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}